import React from 'react';

import { FinishDateFuturePotentialDelayDrivers } from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers';

export const FinishDateFuturePotentialDelayDriversWrapper = ({
    projectId,
    contractId,
    latestVersionId,
    compareVersionId,
    globalFilterData,
}) => {
    if (!globalFilterData?.milestoneFragnet) {
        return null;
    }

    return (
        <FinishDateFuturePotentialDelayDrivers
            projectId={projectId}
            contractId={contractId}
            latestVersionId={latestVersionId}
            compareVersionId={compareVersionId}
            globalFilterData={globalFilterData}
        />
    );
};
